import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeUrl } from '@angular/platform-browser';
import { ICON } from '@core/util/icon';
import { NgxPrintService, PrintOptions } from 'ngx-print';

export interface MapDialogData {
	imageSrc: SafeUrl;
}

@Component({
	selector: 'app-map-dialog',
	templateUrl: './map-dialog.component.html',
	standalone: false,
})
export class MapDialogComponent {
	ICON = ICON;
	public imageSrc: SafeUrl;

	constructor(
		public dialogRef: MatDialogRef<MapDialogComponent>,
		private printService: NgxPrintService,
		@Inject(MAT_DIALOG_DATA) public data: MapDialogData,
	) {
		this.imageSrc = data.imageSrc;
	}

	closeModal(): void {
		this.dialogRef.close();
	}

	printMap = () => {
		const customPrintOptions: PrintOptions = new PrintOptions({
			printSectionId: 'adjacent-lot-map',
			useExistingCss: true,
			openNewTab: false,
		});
		this.printService.print(customPrintOptions);
	};
}
